module.exports = __webpack_public_path__ + "img/teamwork-icon-9.526cdbd8.png";